import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';
import classnames from 'classnames';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import RelationLink from './relationLink';
import { PngFlag } from '../../common/pngFlag';

class MirriFinalOwnersSubSection extends React.Component {
    state = {
        expandMap: {},
        shouldExpandMap: {},
        page: 1,
        totalCount: null,
        loadingTotal: false
    };
    dataRefMap = {};

    get section() {
        var section = this.props.sections.find(o => o.id === this.props.sectionId)
        return section.subsections.find(q => q.id === this.props.subsectionId) || section;
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId || this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ isHistoryExpandedTouched: false });

        const data = this.section.data;

        if (data) {

            var prevItems = null;

            if (this.prevProps) {
                const prevSection = this.prevProps.sections.find(o => o.id === this.prevProps.sectionId);
                if (prevSection) {
                    var prevSubsection = prevSection.subsections.find(q => q.id === this.prevProps.subsectionId);
                    if (prevSubsection) {
                        var prevData = prevSubsection.data;
                        if (prevData) {
                            prevItems = prevData.items;
                        }
                    }
                }
            }

            // run resize only if needed
            if (((prevItems === null || prevItems === undefined) && (data.relationsActual !== null && data.items !== undefined)) ||
                ((prevItems || []).length !== (data.items || []).length)) {
                this._debounce = window.setTimeout(() => this.updateSize(), 250);
            }
        }
    }

    componentDidMount() {
        this.test = window.addEventListener('resize', this.onResize, false)
        this.updateSize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false)
    }

    updateSize = () => {
        this._debounce = undefined;
        if (this.dataRefMap === null || this.dataRefMap === undefined || Object.keys(this.dataRefMap).length === 0) {
            return;
        }
        let shouldExpandMap = { ...this.state.shouldExpandMap };
        let runSetState = false;
        const keys = Object.keys(this.dataRefMap);
        for (let idx = 0; idx < keys.length; idx++) {
            const se = this.dataRefMap[keys[idx]].offsetWidth < this.dataRefMap[keys[idx]].scrollWidth;
            if (shouldExpandMap[keys[idx]] !== se && !this.state.expandMap[keys[idx]]) {
                shouldExpandMap[keys[idx]] = se;
                runSetState = true;
            }
        }
        if (runSetState) {
            this.setState({ shouldExpandMap });
        }
    }

    onResize = e => {
        if (this._debounce !== null && this._debounce !== undefined) {
            window.clearTimeout(this._debounce);
        }
        this._debounce = window.setTimeout(() => this.updateSize(), 250);
    }

    render() {
        if (this.section.name === undefined || this.section.name === null)
            return null;

        const { data, isLimited } = this.section;
        if (isNullOrUndefined(data))
            return null;

        return (
            <>
                <OldStyleTableWithHistory offsetLeft={false} pageSize={this.props.pageSize} isLimited={isLimited} classNames='related-addresses'
                    head={() => this.renderHead()} tableColumns={5} stripped
                    actualData={data.items} actualRow={(r) => this.renderRelationRow(r)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                
                {this.state.loadingTotal && <div style={{ width: "100%", fontSize: "0.1em" }} className="search-progress searching" />}
            </>
        )
    }

    renderHead = () => {
        return (
            <thead className="relations-header">
                <tr>
                    <th><Translate id="Report.EconomicGroup.FinalOwnerName" /></th>
                    <th style={{ width: "3.5em" }}></th>
                    <th><Translate id="Report.EconomicGroup.FinalOwnerId" /></th>
                    <th><Translate id="Report.EconomicGroup.FinalOwnerType" /></th>
                    <th><Translate id="Report.EconomicGroup.FinalOwnerShare" /></th>
                </tr>
            </thead>
        );
    }

    renderRelationRow = (owner) => {
        return (
            <tr key={owner.id} className={classnames('relations-row', 'colorize')}>
                <td className='ellipsed-column'>
                    <RelationLink entityId={owner.id} reports={owner.reports} entityName={owner.name} showOnMobile={true} />
                </td>
                <td><PngFlag countryCode={owner.countryId} title={owner.countryName} /> </td>
                <td>{!isNullOrUndefined(owner.birthDateFormated) ? owner.birthDateFormated : owner.companyId}</td>
                <td>{owner.type}</td>
                <td>{owner.shareFormated}{!isNullOrUndefined(owner.share) ? " %" : ""}</td>
            </tr>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(MirriFinalOwnersSubSection));